module.exports = __webpack_public_path__ + "static/aig-logo-634c2336790eb37ccf6c495017cfcfef.png";